/*
 * The texts of the announcements extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		announcement: {
			create: 'Ankündigung anlegen',
			edit: 'Ankündigung bearbeiten',
			delete: 'Ankündigung löschen',
		},
	},
	modals: {
		edit_announcement: {
			create: 'Neue Ankündigung erstellen',
			edit: 'Ankündigung bearbeiten',
		},
	},
	confirms: {
		remove_announcement: 'Ankündigung entfernen',
		remove_announcement_title: `Die Ankündigung "{title}" entfernen?`,
	},
	data: {
		announcement: {
			id: 'Id',
			title: 'Titel',
			type: 'Typ',
			description: 'Beschreibung',
			url: 'URL',
			start_at: 'Startdatum',
			end_at: 'Enddatum',
		},
	},
	pages: {
		settings: {
			announcements: {
				title: 'Ankündigungen',
			},
		},
	},
	tabs: {
		admin_settings: {
			announcements: 'Ankündigungen',
		},
	},
	widgets: {
		announcements: {
			title: 'Ankündigungen',
		},
	},
};
